const ResetButton = ({ filters, onSubmit }) => {

    const isResetValid = Object.values(filters).some(value => value !== "");

    return (
        <button 
            onClick={onSubmit} 
            style={{ width: "100%", marginTop: "10px" }}
            className={`btn waves-effect waves-light blue ${!isResetValid ? "disabled" : ""}`}
            disabled={!isResetValid}>
            Reset
        </button>
    )
};

export default ResetButton;